import firebase from "firebase/app";
import "firebase/auth";

const app = firebase.initializeApp({
  apiKey: "AIzaSyBT1AK-8tggoiABA4OdiPXIVwRnkzqSzTo",
  authDomain: "react-demos-48c2d.firebaseapp.com",
  databaseURL: "https://react-demos-48c2d-default-rtdb.firebaseio.com",
  projectId: "react-demos-48c2d",
  storageBucket: "react-demos-48c2d.appspot.com",
  messagingSenderId: "999768205163",
  appId: "1:999768205163:web:199810de4c663875ae4e2e",
  measurementId: "G-PZDQ9981FW",
});

export const auth = app.auth();
export default app;
